import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

interface ArchivSelectProps {
  value: string;
  onChange: (value: string) => void;
  width?: string | number;
  size?: "small" | "medium";
}

export default function AbladestellenArchivSelect({
  value,
  onChange,
  width = "150px",
  size = "small",
}: ArchivSelectProps) {
  const handleChange = (e: SelectChangeEvent<string>) => {
    onChange(e.target.value);
  };

  return (
    <FormControl size={size} sx={{ width, ml: 1 }}>
      <InputLabel>Archiv</InputLabel>
      <Select
        label="Archiv"
        size={size}
        value={value ?? "nur aktive"}
        onChange={handleChange}
      >
        <MenuItem value="nur aktive">Nur aktive</MenuItem>
        <MenuItem value="alle">Alle</MenuItem>
        <MenuItem value="nur archivierte">Nur archivierte</MenuItem>
      </Select>
    </FormControl>
  );
}
